// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__G-XR5","messages":"style_messages__7leCb","section":"style_section__WE+l3"};